module.exports = __webpack_public_path__ + "img/thank2.48019063.gif";